import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addeditdata } from "../../../controllers/cms/campus";
import { fetchIpAddress } from "../../../controllers/API";
import imageCompression from "browser-image-compression";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [homepage_image, setHomepageImage] = useState([]);
  const [contactpage_image, setContactpageImage] = useState([]);
  const [admissionpage_image, setAdmissionpageImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    vendor_account_number: ADDEDITDATA?.vendor_account_number || "",
  });

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is used to handle image upload and compression
   *********************************************************/
  const handleHomeImageChnage = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, homepage_image: "Please upload a valid image file." }));
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, homepage_image: "Image must be smaller than 5MB." }));
      return;
    }
    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setHomepageImage([newFile]);
      setError((prev) => ({ ...prev, homepage_image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };


  const handleContactImageChnage = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, contactpage_image: "Please upload a valid image file." }));
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, contactpage_image: "Image must be smaller than 5MB." }));
      return;
    }
    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setContactpageImage([newFile]);
      setError((prev) => ({ ...prev, homepage_image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };

  const handleAdmissionImageChnage = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, admissionpage_image: "Please upload a valid image file." }));
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, admissionpage_image: "Image must be smaller than 5MB." }));
      return;
    }
    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setAdmissionpageImage([newFile]);
      setError((prev) => ({ ...prev, homepage_image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };
  const handleRemove = (file, page) => {
    if(page==='home'){
      setHomepageImage([]); 
    }else if(page==='contact'){
      setContactpageImage([])
    }else if(page==='admission'){
      setAdmissionpageImage([])
    }// Remove only the corresponding image
  };

// End By Md
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        name,
        short_name,
        phone,
        email,
        address,
        age_group,
        content,
        location,
        color
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("editId", _id);
      }
      form.append("name", name);
      form.append("short_name", short_name);
      form.append("phone", phone);
      form.append("email", email);
      form.append("address", address);
      form.append("age_group", age_group);
      form.append("content", content);
      form.append("location", location);
      form.append("color", color);
      if (homepage_image.length > 0) {
        form.append("homepage_image", homepage_image[0]?.originFileObj);
      }
      if (contactpage_image.length > 0) {
        form.append("contactpage_image", contactpage_image[0]?.originFileObj);
      }
      if (admissionpage_image.length > 0) {
        form.append("admissionpage_image", admissionpage_image[0]?.originFileObj);
      }
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: `cms/campuses/addeditdata/${_id ? _id : ':editId'}`,
          postData: form,
        };
        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/campuses");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormData = (form) => {
    if (!form.get("name").trim() || form.get("name").trim() === "undefined" || form.get("name").trim() === null) {
      setError((preError) => ({
        ...preError,
        name: "Campus name is required",
      }));
      return false;
    }
    if (!form.get("short_name").trim() || form.get("short_name").trim() === "undefined" || form.get("short_name").trim() === null) {
      setError((preError) => ({
        ...preError,
        short_name: "Campus short name is required",
      }));
      return false;
    }
    if (!form.get("email").trim() || form.get("email").trim() === "undefined" || form.get("email").trim() === null) {
      setError((preError) => ({
        ...preError,
        email: "Email is required",
      }));
      return false;
    }
    if (!form.get("phone").trim() || form.get("phone").trim() === "undefined" || form.get("phone").trim() === null) {
      setError((preError) => ({
        ...preError,
        phone: "Phone is required",
      }));
      return false;
    }
    if (!form.get("location").trim() || form.get("location").trim() === "undefined" || form.get("location").trim() === null) {
      setError((preError) => ({
        ...preError,
        location: "Location is required",
      }));
      return false;
    }
    if (!form.get("address").trim() || form.get("address").trim() === "undefined" || form.get("address").trim() === null) {
      setError((preError) => ({
        ...preError,
        address: "Address is required",
      }));
      return false;
    }
    if (!ADDEDITDATA?._id && (!form.get("homepage_image") || form.get("homepage_image") == null)) {
      setError((preError) => ({
        ...preError,
        homepage_image: "Image is required",
      }));
      return false;
    }
    if (!ADDEDITDATA?._id && (!form.get("contactpage_image") || form.get("contactpage_image") == null)) {
      setError((preError) => ({
        ...preError,
        contactpage_image: "Image is required",
      }));
      return false;
    }
    if (!ADDEDITDATA?._id && (!form.get("admissionpage_image") || form.get("admissionpage_image") == null)) {
      setError((preError) => ({
        ...preError,
        admissionpage_image: "Image is required",
      }));
      return false;
    }
    if (!ADDEDITDATA?._id && (!form.get("color") || form.get("color") == null)) {
      setError((preError) => ({
        ...preError,
        color: "Color is required",
      }));
      return false;
    }
    return true;
  };

  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Campuses`;
  }, [ADDEDITDATA]);

  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Campuses
            </h5>
          </div>
          <Link to="/cms/campuses">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Name :{" "}
                    </label>
                    <input
                      title="Enter name"
                      placeholder="Enter name"
                      type="text"
                      name="name"
                      className="form-control store_input_field"
                      id="name"
                      value={ADDEDITDATA?.name}
                      onChange={handleChange}
                    />
                    {error.name ? (
                      <p style={{ color: "red" }}>
                        {error.name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="short_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Short Name :{" "}
                    </label>
                    <input
                      title="Enter short name"
                      placeholder="Enter short name"
                      type="text"
                      name="short_name"
                      className="form-control store_input_field"
                      id="short_name"
                      value={ADDEDITDATA?.short_name}
                      onChange={handleChange}
                    />
                    {error.short_name ? (
                      <p style={{ color: "red" }}>
                        {error.short_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Email Address :{" "}
                    </label>
                    <input
                      title="Enter email address"
                      placeholder="Enter email address"
                      type="text"
                      name="email"
                      className="form-control store_input_field"
                      id="email"
                      value={ADDEDITDATA?.email}
                      onChange={handleChange}
                    />
                    {error.email ? (
                      <p style={{ color: "red" }}>
                        {error.email}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="phone no"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Phone No :{" "}
                    </label>
                    <input
                      title="Enter phone number"
                      placeholder="Enter phone number"
                      type="text"
                      name="phone"
                      className="form-control store_input_field"
                      id="phone"
                      value={ADDEDITDATA?.phone}
                      onChange={handleChange}
                    />
                    {error.phone ? (
                      <p style={{ color: "red" }}>
                        {error.phone}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label
                      htmlFor="email"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Location :{" "}
                    </label>
                    <input
                      title="Enter location"
                      placeholder="Enter location"
                      type="text"
                      name="location"
                      className="form-control store_input_field"
                      id="location"
                      value={ADDEDITDATA?.location}
                      onChange={handleChange}
                    />
                    {error.location ? (
                      <p style={{ color: "red" }}>
                        {error.location}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="age_group"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Age group :{" "}
                    </label>
                    <input
                      title="Enter age group"
                      placeholder="Enter age group"
                      type="text"
                      name="age_group"
                      className="form-control store_input_field"
                      id="age_group"
                      value={ADDEDITDATA?.age_group}
                      onChange={handleChange}
                    />
                    {error.age_group ? (
                      <p style={{ color: "red" }}>
                        {error.age_group}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="color"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Background Color :{" "}
                    </label>
                    <input
                      title="Choose color"
                      placeholder="Choose color"
                      type="color"
                      name="color"
                      className="form-control store_input_field"
                      id="color"
                      value={ADDEDITDATA?.color}
                      onChange={handleChange}
                    />
                    {error.color ? (
                      <p style={{ color: "red" }}>
                        {error.color}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                    <label
                      htmlFor="content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Content :
                    </label>
                    <textarea
                      title="Enter content"
                      placeholder="Enter content"
                      type="text"
                      name="content"
                      className="form-control store_input_field"
                      id="content"
                      value={ADDEDITDATA?.content}
                      onChange={handleChange}
                    />
                    {error.content ? (
                      <p style={{ color: "red" }}>{error.content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                    <label
                      htmlFor="address"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Address :
                    </label>
                    <textarea
                      title="Enter address"
                      placeholder="Enter address"
                      type="text"
                      name="address"
                      className="form-control store_input_field"
                      id="address"
                      value={ADDEDITDATA?.address}
                      onChange={handleChange}
                    />
                    {error.address ? (
                      <p style={{ color: "red" }}>{error.address}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Home Page Image
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    listType="picture-card"
                    onChange={handleHomeImageChnage}
                                   fileList={homepage_image}
                                   beforeUpload={() => false} // Prevent automatic upload
                                   onRemove={(file) => handleRemove(file,'home')}
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload Image
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG) of dimesnion 369x547.
                  </p>
                  {error.homepage_image ? (
                    <p style={{ color: "red" }}>{error.homepage_image}</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Contact Page Image
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    listType="picture-card"
                    onChange={handleContactImageChnage}
                                   fileList={contactpage_image}
                                   beforeUpload={() => false} // Prevent automatic upload
                                   onRemove={(file) => handleRemove(file,'contact')}
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload Image
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG) of dimesnion 484x387.
                  </p>
                  {error.contactpage_image ? (
                    <p style={{ color: "red" }}>{error.contactpage_image}</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Admission Page Image
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    listType="picture-card"
                    onChange={handleAdmissionImageChnage}
                                   fileList={admissionpage_image}
                                   beforeUpload={() => false} // Prevent automatic upload
                                   onRemove={(file) => handleRemove(file,'admission')}
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload Image
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG) of dimesnion 532x344.
                  </p>
                  {error.admissionpage_image ? (
                    <p style={{ color: "red" }}>{error.admissionpage_image}</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
